import { WineWidgetModel } from 'shared-widget-components/src/services/FeaturedWinesService';
import useWineUrl from './useWineUrl';

export const useOnWineClick = (wine: WineWidgetModel) => {
  const { createUrl } = useWineUrl();

  const onWineClick = () => {
    // @ts-ignore
    const languageCode = window.currentLanguageCode;

    const url = createUrl(wine.id, wine.title, languageCode);

    // @ts-ignore
    if (window.isAdminPage) return;

    window.location.href = url;
  };

  return { onWineClick };
};
